import { Endpoint } from "@rest-hooks/core";
export const loadIntlMessages = new Endpoint(async function ({ tenant, language, loader }) {
    const messages = tenant
        ? await tenant.getMessages(language)
        : await loader(language);
    return messages ?? {};
}, {
    key({ language, tenant }) {
        return `LOAD messages ${language} ${tenant?.tenantName ?? "default"}`;
    },
    dataExpiryLength: Infinity
});
//# sourceMappingURL=loadIntlMessages.js.map